import React, { useContext } from "react";
import {
  Button,
  Center,
  CircularProgress,
  CircularProgressLabel,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useCountdown } from "./useCounter";
import { GlobalContext } from "../../component/GlobalContext";

const SessionExpired = () => {
  const {
    loggedIn,
    sessionEnd,
    userInfo,
    runCode,
    setSessionEnd,
    setShowLogin,
  } = useContext(GlobalContext);
  const [progress, minutes, seconds, remainingSecs] = useCountdown(1);

  const handleKeepAlive = () => {
    runCode({ code: `show forms`, token: userInfo.token }).then(() => {
      setSessionEnd(false);
    });
  };

  const handleReload = () => {
    setTimeout(() => {
      window.location = "/";
    });
  };

  const handleShowLogin = () => {
    setShowLogin(true);
  };

  return (
    <Modal
      isOpen={!loggedIn && sessionEnd}
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay />
      <ModalContent backgroundColor={"white"}>
        <ModalHeader pb={0}>
          <Center>Session is about to expire!</Center>
        </ModalHeader>
        <ModalBody>
          <Center>
            <VStack>
              <Text>Are you still there?</Text>
              <CircularProgress value={progress} size={"70px"}>
                <CircularProgressLabel>{`${minutes}:${seconds}`}</CircularProgressLabel>
              </CircularProgress>
            </VStack>
          </Center>
          {remainingSecs === 0 && (
            <Center mt={"15px"} as={VStack}>
              <Text fontWeight={"bold"}>Your session has expired.</Text>
              <Text fontWeight={"bold"}>
                Please{" "}
                <b
                  onClick={handleReload}
                  style={{
                    textDecoration: "underline",
                    color: "#009379",
                    cursor: "pointer",
                  }}
                >
                  reload
                </b>{" "}
                this page, or{" "}
                <b
                  onClick={handleShowLogin}
                  style={{
                    textDecoration: "underline",
                    color: "#009379",
                    cursor: "pointer",
                  }}
                >
                  log in
                </b>{" "}
                to start a new session.
              </Text>
            </Center>
          )}
        </ModalBody>
        <ModalFooter>
          {remainingSecs > 0 && (
            <Button
              colorScheme="teal"
              variant="solid"
              size={"sm"}
              onClick={handleKeepAlive}
            >
              Keep session alive
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SessionExpired;
